module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/86eb92c49b19cd572a1f7b36f1a41245.gif";